import { PartyType } from '@parties/src/types';
import { useQuery } from 'react-query';
import { wgApi } from '../../../../../app/src/features/api/wgApi';

interface AnvaFlowsCompaniesResponse {
  items: AnvaFlowsCompany[];
}
export interface AnvaFlowsCompany {
  id: string;
  name: string;
  code: string;
  form: string;
  form_description: string;
}

export const getAnvaFlowsCompanies = async (
  partyType: PartyType,
  insurancesIds?: number[],
  coverageIds?: string[],
) => {
  const { data, isError } = await wgApi.get<AnvaFlowsCompaniesResponse>(
    `/v1/api/anvaflows/supported-insurance-companies`,
    {
      query: {
        insurance_ids: insurancesIds,
        coverage_codes: coverageIds,
        party_type: partyType,
      },
    },
  );
  if (isError) throw new Error();
  return data;
};

const getUseAnvaFlowsCompaniesQkey = (
  partyType: PartyType,
  insuranceIds?: number[],
  coverageIds?: string[],
) => ['flow-config', 'anva', 'companies', partyType, insuranceIds, coverageIds];

export const useAnvaFlowsCompanies = (
  partyType: PartyType,
  insuranceIds?: number[],
  coverageIds?: string[],
) => {
  return useQuery(
    getUseAnvaFlowsCompaniesQkey(partyType, insuranceIds, coverageIds),
    () => getAnvaFlowsCompanies(partyType, insuranceIds, coverageIds),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: !!insuranceIds,
    },
  );
};
